import { render, staticRenderFns } from "./helplist.vue?vue&type=template&id=f115f5d4&"
import script from "./helplist.vue?vue&type=script&lang=js&"
export * from "./helplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports